import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './VastuSubHeader.css';

const VastuSubHeader = () => {
  const { user, hasVastuConsultantAccess } = useAuth();

  const isVastuConsultantUser = user?.role === 'admin' || (
    ['consultant', 'vastu_consultant'].includes(user?.role) || hasVastuConsultantAccess
  );

  return (
    <div className="vastu-sub-header">
      <div className="container sub-header-container">
        <nav className="vastu-sub-nav">
          <NavLink 
            to="/vastu/book" 
            end 
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <i className="fas fa-file-invoice"></i> Book Consultation
          </NavLink>

          {/* --- NEW LINK: BROWSE ALL EXPERTS --- */}
          <NavLink 
            to="/vastu/consultants" 
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <i className="fas fa-user-friends"></i> Our Experts
          </NavLink>
          {/* ------------------------------------ */}
          
          <NavLink 
            to="/dashboard/vastu-consultations" 
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <i className="fas fa-folder-open"></i> My Consultations
          </NavLink>

          {isVastuConsultantUser && (
            <NavLink 
              to="/vastu-consultant-desk" 
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <i className="fas fa-user-tie"></i> Consultant Desk
            </NavLink>
          )}
        </nav>
      </div>
    </div>
  );
};

export default VastuSubHeader;